import {
  LanguageCodes,
  languages,
  languageSlugAliases,
} from 'js/locale/constants'

function localizeLink(
  path: `/${string}/?${string}`,
  currentLanguage: LanguageCodes,
)
function localizeLink(path: `/${string}/`, currentLanguage: LanguageCodes)
function localizeLink(path: `/`, currentLanguage: LanguageCodes)
function localizeLink(path: string, currentLanguage: LanguageCodes = 'en') {
  if (currentLanguage !== 'en') {
    return `/${currentLanguage}${path}`
  } else {
    return `${path}`
  }
}

function unlocalizePathname(pathname: string) {
  const match = pathname.match(/^\/([^/]+)(\/|$)/i)
  if (match) {
    const slug = match[1].toLowerCase()
    const normalized = languageSlugAliases[slug] ?? slug

    if (languages.includes(normalized as LanguageCodes)) {
      const remainder = pathname.slice(match[0].length)
      if (!remainder) {
        return ''
      }

      return remainder.startsWith('/') ? remainder : `/${remainder}`
    }
  }

  return pathname
}

export { localizeLink, unlocalizePathname }
